export default {
  title: {
    en: 'Reset your password',
  },
  text: {
    en: 'Due to a security update we require you to update your password. Thank you for understanding!',
  },
}
